<template>
  <v-app id="keep">
    <v-navigation-drawer app clipped width="300" color=""  :mini-variant.sync="navMini" disable-resize-watcher>
      <sysNavPanel @minify="switchMinify" :mini="navMini" :show-minify="showDrawer"/>
      <template v-slot:append>
        <sys-application-menu class="pa-2" style="position: absolute; bottom: 30px;" v-if="showDrawer" />
        <address-card v-else/>
      </template>
    </v-navigation-drawer>
    <v-main>
      <v-container :class="'fill-height pt-0 align-start'">
        <router-view />
        <sysBusyDialog />
        <Snackbar />
      </v-container>
    </v-main>
    <v-footer app color="info" class="white--text" v-if="showDrawer && uiConf.showFooter">
      <span class="gagat--text" v-if="uiConf.copyright">© {{uiConf.copyright}} </span>
      <div class="info--text" >Сборка 20240902.2136 dev</div>
      <v-spacer></v-spacer>
      <span v-if="uiConf.contactPhone">
        <v-icon class="gagat--text mr-2">mdi-phone-classic</v-icon><a :href="'tel:' + uiConf.contactPhone" class="gagat--text">{{uiConf.contactPhone}}</a>
      </span>
      <span v-if="uiConf.mailAddress">
        <v-icon class="gagat--text mr-2 pl-4">mdi-email</v-icon><a :href="'mailto:' + uiConf.mailAddress" class="gagat--text">{{uiConf.mailAddress}}</a>
      </span>
      <!-- <span>&copy; Веб-разработка, {{new Date().getFullYear() }}</span> -->
    </v-footer>
  </v-app>
</template>

<script>
import { UI_ALLOW_LONGPOLL, UI_INIT_UI } from './store/actions/ui'
import { CLM_DATA_LONGPOLL } from './store/actions/claims'

export default {
  components: {
    sysNavPanel: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/ui/navpanel.vue'),
    AddressCard: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/ui/addressCard'),
    SysApplicationMenu: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/ui/appMenu.vue'),
    sysBusyDialog: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/dialogs/sysBusyDialog.vue'),
    Snackbar: () => import(/* webpackChunkName: "commonUI" */ '@/components/common/snackbar.vue')
  },
  data: () => ({
    navMini: false
  }),
  computed: {
    showDrawer: function () {
      return this.$store.getters.isAuthenticated
    },
    uiConf: {
      get: function () {
        return this.$store.getters.getUIConf
      }
    }
  },
  methods: {
    switchMinify (signal) {
      // console.log('Accepted minify command', signal)
      this.navMini = signal
    },
    initLongpolls () {
      setTimeout(this.initLongpolls, 30000)
      if (this.showDrawer) {
        this.dispLongpoll()
      }
    },
    dispLongpoll () {
      this.$store.dispatch(UI_ALLOW_LONGPOLL, 'on')
      this.$store.dispatch(CLM_DATA_LONGPOLL)
        .catch((err) => {
          console.log('Delayed data update failed: ', err)
        })
    }
  },
  created: function () {
    console.log('Application created')
    this.$store.dispatch(UI_INIT_UI)
    this.initLongpolls()
  }
}
</script>

<style>
</style>
